
export class BillItemDeleted {

  public ChargeItemCode: number;
}
export class PrescribingDoctor {
    public DoctorName: string;
    public DoctorCode: number;
    public Designation: string;
}
export class ReferringDoctor {
    public DoctorName: string;
    public DoctorCode: number;
    public Designation: string;
}
export class BillDetails {
  public SequenceNo: number;
  public ChargeItemID: string;
  public ItemCode: number;
  public ServiceDescription: string;
  public Quantity: number;
  public UnitPrice: number;
  public BranchBasePrice: number;
  public Discount: number;
  public ItemRate: number;
  public RowNumber: number;
  public Edit: boolean;
  public ServiceCode: number;
  public ItemType: string;
  public ItemGroup: string;
  public GroupName: string;
  public IsPackage: boolean;
  public PackageName: string;
  public ChargeItemCode: number;
  public DiscountAllowed: boolean;
  public rDiscount: number;
  public CanModify: boolean;
  public IsDeleted: boolean = false;  // editing purposes only... 
  public EditableCharge: boolean;
  public RefundableAmount: number;
  public RefundableQuantity: number;
  public TaxPercentage: number;
  public ProviderCode: number;
  public ProviderName: string;
  public ExpiryDate: Date;
  public BatchNumber: string;
  public SupplierBatchDetails: string;
  public SupplierMaterialBatchCode: number;
  public IsSelected: boolean;
  public RefundQuantity: number;
}

//export class BillDetails {
//  public ExpiryDate: Date;
//  public BatchNumber: string;
//  public SupplierBatchDetails: string;
//  public SupplierMaterialBatchCode: number;

//}
//export class BillDetails {

//  public IsSelected: boolean;
//  public RefundQuantity: number;

//}



